import SuccessIcon from "../../icons/SuccessIcon";
import WarningIcon from "../../icons/WarningIcon";
import Spinner from "../../spinner/Spinner";

export const WizardReceipt = (props: {
  children?: React.ReactNode;
  className?: string;
  heading?: string;
  icon: "success" | "warning" | "loading";
}) => {
  const { children, className, heading, icon } = props;

  return (
    <div className={`c-receipt c-modal-container-inner ${className ?? ""}`}>
      <div className="text-center">
        {icon === "loading" && (
          <span>
            <Spinner size={32} />
          </span>
        )}
        {icon === "warning" && (
          <span className="text-danger">
            <WarningIcon width={32} />
          </span>
        )}
        {icon === "success" && (
          <span className="text-success">
            <SuccessIcon width={32} />
          </span>
        )}
      </div>
      <h2 className="text-center my-2">{heading}</h2>
      <div className="my-4">{children}</div>
    </div>
  );
};
